import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import { Link } from 'react-router-dom';
import imageNotFound from '../../../assets/no_logo_found.png';
import { useAppStoreDispatch, useAppStoreSelector } from '../../../store';
import { toggleDrawer } from '../../app/store';
import { Portals } from '../../portal/store';

// enum ALLOWED_SIZES {
//   small = 'small',
//   medium = 'medium',
//   large = 'large',
//   xlarge = 'xlarge',
// }

const PORTAL_WIDTH_SIZES = {
  small: '12rem',
  medium: '18rem',
  large: '21rem',
  xlarge: '25rem',
};

const PORTAL_PADDING_SIZES = {
  small: '0.25rem',
  medium: '0.75rem',
  large: '1.25rem',
  xlarge: '1.35rem',
};

function Widget({ portal }: { portal: Portals }) {
  const settingsState = useAppStoreSelector((state) => state.settings.data);
  const dispatch = useAppStoreDispatch();

  if (!settingsState) return null;

  return (
    <Card
      className="ps"
      sx={{
        maxWidth: PORTAL_WIDTH_SIZES[settingsState.sizes.widgets],
        width: '100%',
        overflow: 'hidden',
      }}
    >
      <Link
        to={`/portal/${portal.portalID}`}
        style={{
          textDecoration: 'none',
          height: '100%',
          color: 'inherit',
        }}
        target={
          settingsState?.isNewPageChecked ? portal.portalID.toString() : ''
        }
        onClick={() => dispatch(toggleDrawer(false))}
      >
        {portal.portalWidgetImageValue ? (
          <Box
            sx={{
              width: "100%",
              height: "160px",
              overflow: "hidden",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#fff",
            }}
          >
            <CardMedia
              component="img"
              image={
                portal.portalWidgetImageValue
                  ? portal.portalWidgetImageValue
                  : settingsState?.noImage
                    ? settingsState.noImage
                    : imageNotFound
              }
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                objectPosition: "center",
              }}
            />
          </Box>
        ) : settingsState?.noImage ? (
          <CardMedia
            component="img"
            sx={{ minHeight: '15rem', objectFit: 'contain' }}
            image={settingsState.noImage}
          />
        ) : (
          <Box
            sx={{
              width: '100%',
              height: '12.5rem',
              padding: '1rem',
              backgroundColor: '#f7f7f7',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Box component="img" src={imageNotFound} sx={{ width: '50%' }} />
          </Box>
        )}
        <Divider />
        <CardContent
          sx={{
            padding:
              PORTAL_PADDING_SIZES[
              settingsState.sizes.widgets
              ],
          }}
        >
          <Typography variant="h6" component="div">
            {portal.portalWidgetHeadline}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {portal.portalWidgetText}
          </Typography>
        </CardContent>
        {/* <Card.Header */}
        {/*   className="text-primary" */}
        {/*   style={{ */}
        {/*     textAlign: 'right', */}
        {/*     // fontSize: */}
        {/*     //   PORTAL_FONT_SIZES[ */}
        {/*     //     settingsState!.generalSetup.overralSettings.widgets.size */}
        {/*     //   ], */}
        {/*     borderBottom: 0, */}
        {/*   }} */}
        {/* > */}
        {/* <Link */}
        {/*   to={`/portal/${portal.portalID}`} */}
        {/*   className="btn btn-outline-primary" */}
        {/*   target={ */}
        {/*     settingsState?.isNewPageChecked ? portal.portalID.toString() : '' */}
        {/*   } */}
        {/*   onClick={() => dispatch(toggleDrawer(false))} */}
        {/* > */}
        {/*   Access Portal */}
        {/* </Link> */}
        {/* </Card.Header> */}
      </Link>
    </Card>
  );
}

export default Widget;
